import { useEffect, useState } from "react";
const BrokerDropdown = ({
  className,
  data,
  setDematData,
  valueKey,
  displayKey,
  filterKey,
  setFilter,
}) => {
  const [value, setValue] = useState();
  const [uniqueBrokers, setUniqueBrokers] = useState([]);
  useEffect(() => {
    if (value && value !== "") {
      setFilter((prev) => ({ ...prev, [filterKey]: value }));
      const filterDemat = data?.filter(
        (item) =>
          item[valueKey] === (/^\d+$/.test(value) ? Number(value) : value),
      );
      setDematData(filterDemat);
    } else {
      setFilter((prev) => ({ ...prev, [filterKey]: null }));
      setDematData([]);
    }
  }, [value, data]);

  useEffect(() => {
    const unique = {};
    const uniqueData = data?.filter((item) => {
      if (!unique[item[displayKey]]) {
        unique[item[displayKey]] = true;
        return true;
      }
      return false;
    });
    setUniqueBrokers(uniqueData);
  }, [data]);

  return (
    <div className="flex h-full w-full flex-col gap-2 rounded-[4px] bg-[#f5f5f5]">
      <div className="h-full rounded bg-transparent px-[1px] py-[1px] ">
        <select
          className={`${
            className ? className : "w-full"
          }   bg-transparent py-[0.4rem] text-[14px] text-[#868686]  focus:outline-none`}
          defaultValue={false}
          onChange={(e) => setValue(e.target.value)}
        >
          <option value={""} className="text-[#CFCFCF]">
            Select Broker Name
          </option>
          {uniqueBrokers?.map((item) => (
            <option value={item[valueKey]} className="text-[#868686]">
              {item[displayKey]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default BrokerDropdown;
